<template>
  <div class="local-wrap">
    <!-- TODO lichun: 使用computed处理，type要从常量拿 -->
    <div v-if="isImage" class="img-wrap">
      <el-image :src="item.downloadUrl" fit="scale-down"
        ><div slot="placeholder" class="image-loading" v-loading="true"></div>
      </el-image>
      <footer>
        <div>
          版权声明：您应尊重相关著作人合法权益，未经著作权人合法授权，不能违法上传、存储、分享他人作品
        </div>
        <div>本内容由用户通过<span class="app">MAXHUB文档</span>发布，并不代表视臻公司立场</div>
      </footer>
    </div>
  </div>
</template>

<script>
import Constants from '@constants';

export default {
  name: 'LocalDocPreview',
  data() {
    return {};
  },
  props: {
    item: {
      Type: Object,
      default: () => {}
    }
  },
  computed: {
    isImage() {
      const contentType = this.item.contentType.toLowerCase();
      return Constants.Common.IMGTYPE.includes(contentType);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './LocalDocPreview';
</style>
